var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandHoldingHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1181 19.618C19.6042 20.1319 20.3958 20.1319 20.8889 19.618L28.4514 11.6875C30.6458 9.38192 30.5208 5.56248 28.0625 3.43748C25.9236 1.58331 22.7361 1.91664 20.7778 3.9722L20 4.7847L19.2292 3.97914C17.2708 1.91664 14.0833 1.58331 11.9444 3.43748C9.49306 5.56248 9.36111 9.38192 11.5556 11.6875L19.1181 19.618ZM39.2569 25.0069C38.4375 24.2639 37.1597 24.3125 36.2986 25.0069L29.8819 30.1389C29.0972 30.7708 28.1181 31.1111 27.1042 31.1111H18.8889C18.2778 31.1111 17.7778 30.6111 17.7778 30C17.7778 29.3889 18.2778 28.8889 18.8889 28.8889H24.3264C25.4306 28.8889 26.4583 28.1319 26.6389 27.0416C26.8681 25.6528 25.7986 24.4444 24.4444 24.4444H13.3333C11.4583 24.4444 9.64583 25.0903 8.1875 26.2708L4.95833 28.8889H1.11111C0.5 28.8889 0 29.3889 0 30V36.6666C0 37.2778 0.5 37.7778 1.11111 37.7778H25.8889C26.8958 37.7778 27.875 37.4375 28.6667 36.8055L39.1667 28.4028C40.2222 27.5625 40.3056 25.9514 39.2569 25.0069Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHoldingHeart);
export default __webpack_public_path__ + "static/media/hand-holding-heart.7e61036b916b67c84e1fc2ee37bf0e8b.svg";
export { ForwardRef as ReactComponent };